import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import Tutorial from "../../../../Tutorial";

import messages from "./messages";
import { IProps } from "./interfaces";

const EmbedTutorial = ({ close, title }: IProps) => (
    <Tutorial close={close} title={title}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: <FormattedHTMLMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title2} />,
                content: <FormattedHTMLMessage {...messages.description2} />,
            },
        ]}
    </Tutorial>
);

export default EmbedTutorial;
